<template>
    <div class="_tipbox" ref="tipbox">
        <slot/>
        <div v-show="!large" v-if="variable" class="boundary n-resize" ref="n_resize" :style="{height: t_size + 'px', top: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary e-resize" ref="e_resize" :style="{width: t_size + 'px', right: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary s-resize" ref="s_resize" :style="{height: t_size + 'px', bottom: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary w-resize" ref="w_resize" :style="{width: t_size + 'px', left: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary ne-resize" ref="ne_resize" :style="{width: t_size + 'px',height: t_size + 'px', right: -t_offset + 'px',top: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary nw-resize" ref="nw_resize" :style="{width: t_size + 'px',height: t_size + 'px', left: -t_offset + 'px',top: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary se-resize" ref="se_resize" :style="{width: t_size + 'px',height: t_size + 'px', right: -t_offset + 'px',bottom: -t_offset + 'px'}"></div>
        <div v-show="!large" v-if="variable" class="boundary sw-resize" ref="sw_resize" :style="{width: t_size + 'px',height: t_size + 'px', left: -t_offset + 'px',bottom: -t_offset + 'px'}"></div>
    </div>
</template>

<script>
export default {
    name: "MoveWrap",
    data() {
        return {
            top: '',
            left: '',
            width: '',
            height: '',
            // 触发区域大小
            t_size: 8,
            // 偏移量
            t_offset: 4
        }
    },
    props: {
        resizeData: Object,
        center: Boolean,
        large: Boolean,
        variable: Boolean
    },
    methods: {
        large_change(large) {
            let tipbox = this.$refs.tipbox,
                wrap = tipbox.parentNode;

            let wrapWidth = wrap.clientWidth, wrapHeight = wrap.clientHeight
            if(wrapWidth == 0 && wrapHeight == 0) {
                wrapWidth = window.screen.width
                wrapHeight = window.screen.height
            }
            tipbox.style.transition = 'all .24s cubic-bezier(0,1.13,.93,.99)';
            tipbox.addEventListener('transitionend', function (e) {
                tipbox.style.transition = '';
            }, { once: true })

            this.$nextTick(_=>{
                try {
                    if (large === true) {
                        parseFloat(tipbox.style.width) < wrapWidth && (this.width = tipbox.style.width)
                        parseFloat(tipbox.style.height) < wrapHeight && (this.height = tipbox.style.height)

                        tipbox.style.width = wrapWidth + "px";
                        tipbox.style.height = wrapHeight + "px";
                        this.top = tipbox.style.top
                        this.left = tipbox.style.left
                        tipbox.style.top = 0
                        tipbox.style.left = 0
                    } else if (large === false) {
                        this.width && (tipbox.style.width =  this.width);
                        this.height && (tipbox.style.height = this.height);
                        this.top && (tipbox.style.top = this.top)
                        this.left && (tipbox.style.left = this.left)
                        this.width = '';
                        this.height = '';
                        this.top = '';
                        this.left = '';
                    }
                } catch (error) {
                    
                }
            })
        },
        bind () {
            let refs = this.$refs,
                n_resize = refs.n_resize,
                e_resize = refs.e_resize,
                s_resize = refs.s_resize,
                w_resize = refs.w_resize,
                ne_resize = refs.ne_resize,
                nw_resize = refs.nw_resize,
                se_resize = refs.se_resize,
                sw_resize = refs.sw_resize;

            let t_size = this.t_size;

            function create (header,move) {

                let el = refs.tipbox,
                    wrap = document;

                header.onmousedown = function(e){
                    
                    e.preventDefault();//清除默认行为

                    if (e.button != 0) return 

                    var wrap_height = wrap.clientHeight,
                        wrap_width = wrap.clientWidth;

                    var startY = e.clientY,
                        startX = e.clientX;

                    var aboveY = parseFloat(el.style.top || 0),
                        aboveX = parseFloat(el.style.left || 0);

                    var sizeY = el.clientHeight,
                        sizeX = el.clientWidth;

                    let i_move = function (e) {

                        e.preventDefault();//清除默认行为

                        let offset_y = e.clientY - startY;
                        let offset_x = e.clientX - startX;

                        // 不够阈值不触发移动
                        if (Math.abs(offset_y) < 5 && Math.abs(offset_x) < 5) return;
                        
                        var y = aboveY + offset_y,
                            x = aboveX + offset_x;

                        move({
                            el,
                            setTop: _=>{
                                if (y < 0) {
                                    el.style.top = 0 + 'px';
                                }else if(wrap_height - el.clientHeight >= 0 && y > (wrap_height - el.clientHeight)) {
                                    el.style.top = wrap_height - el.clientHeight + 'px';
                                }else {
                                    el.style.top = y + 'px'
                                    return true
                                }
                            },
                            setLeft: _=>{
                                if (x < 0) {
                                    el.style.left = 0 + 'px';
                                } else if (wrap_width - el.clientWidth >= 0 && x > (wrap_width - el.clientWidth)){
                                    el.style.left = wrap_width - el.clientWidth + 'px';
                                } else {
                                    el.style.left = x + 'px';
                                    return true
                                }
                            },
                            offset_y,
                            offset_x,
                            sizeY,
                            sizeX
                        })    
                    }

                    wrap.addEventListener('mousemove',i_move,false);

                    wrap.onmouseup = function(e){

                        wrap.removeEventListener('mousemove',i_move,false);

                        e.preventDefault();//清除默认行为

                        wrap.onmouseup = null;

                        if (el.offsetTop < t_size) {
                            el.style.height = el.clientHeight + el.offsetTop + 'px'
                            el.style.top = '0px'
                        }

                        if (el.offsetLeft < t_size) {
                            el.style.width = el.clientWidth + el.offsetLeft + 'px'
                            el.style.left = '0px'
                        }

                        let offsetBottom = el.parentNode.clientHeight - el.clientHeight - el.offsetTop,
                            offsetRight = el.parentNode.clientWidth - el.clientWidth - el.offsetLeft;

                        if (offsetBottom < t_size) {
                            el.style.height = el.clientHeight + offsetBottom + 'px'
                            el.style.bottom = '0px'
                        }

                        if (offsetRight < t_size) {
                            el.style.width = el.clientWidth + offsetRight + 'px'
                            el.style.right = '0px'
                        }
                            

                    }
                }
            }

            // 上
            create(n_resize,data=>{

                var el = data.el;

                let minHeight = parseFloat(el.style.minHeight);
                
                if (minHeight <= data.sizeY - data.offset_y && data.setTop()) {
                    el.style.height = data.sizeY - data.offset_y + 'px';
                }
            })
            // 右
            create(e_resize,data=>{

                var el = data.el,
                    wrap = el.parentNode;

                let minWidth = parseFloat(el.style.minWidth),
                    width = data.sizeX + data.offset_x;

                if (minWidth <= width && (width + el.offsetLeft) < wrap.clientWidth) 
                    el.style.width = width + 'px';

            })
            // 下
            create(s_resize,data=>{

                var el = data.el,
                    wrap = el.parentNode;

                let minHeight = parseFloat(el.style.minHeight),
                    height = data.sizeY + data.offset_y;
                
                if (minHeight <= height && (height + el.offsetTop) <= wrap.clientHeight) 
                    el.style.height = height + 'px';

            })
            // 左
            create(w_resize,data=>{

                var el = data.el;

                let minWidth = parseFloat(el.style.minWidth);

                if (minWidth <= data.sizeX - data.offset_x && data.setLeft()) {
                    el.style.width = data.sizeX - data.offset_x + 'px';
                }
            })
            // 上右
            create(ne_resize,data=>{

                var el = data.el,
                    wrap = el.parentNode;

                let minHeight = parseFloat(el.style.minHeight);
                let minWidth = parseFloat(el.style.minWidth),
                    width = data.sizeX + data.offset_x;

                if (minHeight <= data.sizeY - data.offset_y && data.setTop()) {
                    el.style.height = data.sizeY - data.offset_y + 'px';
                }
                if (minWidth <= width && (width + el.offsetLeft) < wrap.clientWidth) 
                    el.style.width = data.sizeX + data.offset_x + 'px';

            })
            // 上左
            create(nw_resize,data=>{

                var el = data.el;

                let minWidth = parseFloat(el.style.minWidth),
                    minHeight = parseFloat(el.style.minHeight);
                
                if (minHeight <= data.sizeY - data.offset_y && data.setTop()) {
                    el.style.height = data.sizeY - data.offset_y + 'px';
                }
                    
                if (minWidth <= data.sizeX - data.offset_x && data.setLeft()) {
                    el.style.width = data.sizeX - data.offset_x + 'px';
                }
            })
            // 下右
            create(se_resize,data=>{

                var el = data.el,
                    wrap = el.parentNode;

                let minHeight = parseFloat(el.style.minHeight),
                    height = data.sizeY + data.offset_y;

                let minWidth = parseFloat(el.style.minWidth),
                    width = data.sizeX + data.offset_x;
                
                if (minHeight <= height && (height + el.offsetTop) < wrap.clientHeight) 
                    el.style.height = height + 'px';

                if (minWidth <= width && (width + el.offsetLeft) < wrap.clientWidth) 
                    el.style.width = width + 'px';

            })
            // 下左
            create(sw_resize,data=>{

                var el = data.el,
                    wrap = el.parentNode;

                let minWidth = parseFloat(el.style.minWidth),
                    minHeight = parseFloat(el.style.minHeight),
                    height = data.sizeY + data.offset_y;
                
                if (minHeight <= height && (height + el.offsetTop) < wrap.clientHeight) 
                    el.style.height = height + 'px';

                if (minWidth <= data.sizeX - data.offset_x && data.setLeft()) {
                    el.style.width = data.sizeX - data.offset_x + 'px';
                }

            })

        },
        init() {
            let tipbox = this.$refs.tipbox,
                wrap = tipbox.parentNode;

            if (this.center) {
                //若弹框高度>父节点高度，则top = 0;
                //若弹框宽度>父节点宽度，则left = 0;
                tipbox.style.top = (wrap.offsetHeight>tipbox.offsetHeight) ? ((wrap.offsetHeight - tipbox.offsetHeight)/2 + 'px') : '0px';
                tipbox.style.left = (wrap.offsetWidth>tipbox.offsetWidth) ? ((wrap.offsetWidth - tipbox.offsetWidth)/2 + 'px') : '0px';
            }
        },
        panelResize(data) {
            this.$nextTick(this.init)
        }
    },
    mounted () {
        let tipbox = this.$refs.tipbox,
            wrap = tipbox.parentNode;

        this.variable && this.bind()

        this.init()
        
        this.large_change(this.large)
    },
    watch: {
        resizeData: 'panelResize',
        large: 'large_change'
    }
}
</script>

<style scoped>
    ._tipbox {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .boundary {
        position: absolute;
        /* background: lightpink; */
    }

    .n-resize {
        left: 0;
        width: 100%;
        cursor: n-resize;
    }
    .e-resize {
        top: 0;
        height: 100%;
        cursor: e-resize;
    }
    .s-resize {
        left: 0;
        width: 100%;
        cursor: s-resize;
    }
    .w-resize {
        top: 0;
        height: 100%;
        cursor: w-resize;
    }

    .ne-resize {
        cursor: ne-resize;
        /* background:limegreen; */
    }
    .nw-resize {
        cursor: nw-resize;
        /* background:limegreen; */
    }
    .se-resize {
        cursor: se-resize;
        /* background:limegreen; */
    }
    .sw-resize {
        cursor: sw-resize;
        /* background:limegreen; */
    }
</style>